import { render } from "./StoreManagement.vue?vue&type=template&id=ff8e10fc&scoped=true"
import script from "./StoreManagement.vue?vue&type=script&lang=js"
export * from "./StoreManagement.vue?vue&type=script&lang=js"

import "./StoreManagement.vue?vue&type=style&index=0&id=ff8e10fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8e10fc"]])

export default __exports__